import getJWT from './getJWT';

const bucketUploader = async (formData) => {
  const urlBase = process.env.REACT_APP_APIURL;
  try {
    const response = await fetch(
      `${urlBase}/upload_apto_medico`,
      {
        method: 'POST',
        body: formData,
        headers: {
          'X-Access-Tokens': getJWT(),
        },
      }
    );

    if (response.ok) {
      return response;
    } else {
      console.error('Error del backend:', response?.result.error);
    }
  } catch (error) {
    console.error('Error subiendo archivo al backend', error);
  }
};

export default bucketUploader;
